"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var prop_types_1 = require("prop-types");

var propTypes = {
  className: prop_types_1.string,
  classModifier: prop_types_1.string
};
var defaultProps = {
  className: null,
  classModifier: null
};
exports["default"] = {
  propTypes: propTypes,
  defaultProps: defaultProps
};